import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import type { User } from '@/types'

interface AuthState {
  user:          User | null
  accessToken:   string | null
  refreshToken:  string | null
  isAuthenticated: boolean

  // Actions
  login:          (user: User, accessToken: string, refreshToken: string) => void
  logout:         () => void
  setUser:        (user: User) => void
  setAccessToken: (token: string) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user:            null,
      accessToken:     null,
      refreshToken:    null,
      isAuthenticated: false,

      login: (user, accessToken, refreshToken) =>
        set({
          user,
          accessToken,
          refreshToken,
          isAuthenticated: true,
        }),

      logout: () =>
        set({
          user:            null,
          accessToken:     null,
          refreshToken:    null,
          isAuthenticated: false,
        }),

      setUser: (user) => set({ user }),

      setAccessToken: (accessToken) => set({ accessToken }),
    }),
    {
      name:    'sporokulu-auth',
      storage: createJSONStorage(() => localStorage),
      // Only persist tokens + user (not derived state)
      partialize: (state) => ({
        user:         state.user,
        accessToken:  state.accessToken,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
)
